



































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import PageNames from '@/router/PageNames';
import IntegrationDto from '@/models/Integrations/IntegrationDto';

@Component({
  name: 'XeroAuthCallback',
})
export default class XeroAuthCallback extends GiganautVue {
  loading = true;
  error: string | null = null;
  isSuccess = false;
  integrationId = '';

  async created() {
    // Extract code and state from URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    
    // Retrieve the integration ID from session storage
    this.integrationId = sessionStorage.getItem('xero_integration_id') || '';
    
    if (!code || !state) {
      this.error = 'Missing required authentication parameters';
      this.loading = false;
      return;
    }

    try {
      // Complete the Xero OAuth flow
      await AgencySettingsModule.completeXeroAuth({ code, state });
      this.isSuccess = true;
      
      // Clear the integration ID from session storage
      sessionStorage.removeItem('xero_integration_id');
      
      // If successful, refresh the integration data
      if (this.integrationId) {
        await AgencySettingsModule.getIntegrationById(this.integrationId);
      }
    } catch (error) {
      this.error = 'Failed to complete Xero authentication';
      console.error('Error completing Xero authentication:', error);
    } finally {
      this.loading = false;
    }
  }

  navigateToIntegration() {
    if (this.integrationId) {
      this.$router.push({ name: PageNames.AgencyIntegrationDetails, params: { integrationid: this.integrationId } });
    } else {
      this.$router.push({ name: PageNames.AgencyIntegrationSettings });
    }
  }
}
